import classNames from 'classnames'

import type { PropsWithChildren, ReactElement } from 'react'

import './styles.scss'

export interface Props {
  className?: string
}

const ViewTitle = ({ children, className }: PropsWithChildren<Props>): ReactElement => {
  const viewTitleClasses = classNames('view-title', className)

  return <div className={viewTitleClasses}>{children}</div>
}

export default ViewTitle
